import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SPaymentDetailsPageContentRow = styled.div`
  gap: 20px;

  ${setFlexDF};
`;
